/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_ListInputs */

const en_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New List`)
};

const fr_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle liste`)
};

const de_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Liste`)
};

const it_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo elenco`)
};

const ru_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый список`)
};

const es_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva lista`)
};

const zh_cn2_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新列表`)
};

const ja_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいリスト`)
};

const hi_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई सूची`)
};

const pt_pt2_new_list = /** @type {(inputs: New_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova lista`)
};

/**
* | output |
* | --- |
* | "New List" |
*
* @param {New_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_list = /** @type {((inputs?: New_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_list(inputs)
	if (locale === "de") return de_new_list(inputs)
	if (locale === "it") return it_new_list(inputs)
	if (locale === "ru") return ru_new_list(inputs)
	if (locale === "es") return es_new_list(inputs)
	if (locale === "zh-CN") return zh_cn2_new_list(inputs)
	if (locale === "ja") return ja_new_list(inputs)
	if (locale === "hi") return hi_new_list(inputs)
	if (locale === "pt-PT") return pt_pt2_new_list(inputs)
	return en_new_list(inputs)
});